import React from 'react';
import { getGRC, getLogin } from '../../service/adminApi';
import { getroleName, getSecAudits } from '../../service/adminApi';
import { getHiringTeamLogin } from '../../service/RecruiterApi';
import './Login.css';
import Loader from '../../StaticComponent/Loader';

import { encryptStorage } from '../../constant';


// import { EncryptStorage } from 'encrypt-storage'

// export const encryptStorage = new EncryptStorage('edbe38e0-748a-49c8-9f8f-b68f38dbe5a2', {

//     stateManagementUse: true,
//     storageType: 'encryptStorage'
// });

function LoginAuth() {
    const currentYear = new Date().getFullYear();
    
    const [isLoading, setIsLoading] = React.useState(true);
    React.useEffect(() => {
        
        getDetails();
    }, []);

    let search = window.location.search;
    let code = new URLSearchParams(search).get('code');

    let source = '';
    if (window.location.hostname == 'localhost') {
        source = 'local';
    } else {
        source = 'deployed';
    }
    const getDetails = async () => {
        
        let data = {
            modulename: 10,
            methodname: 1,
            payload: { code, source },

            // private_key: PRIVATE_KEY,
        };
        setIsLoading(false);
        
        let res = await getLogin(data);

        //res = JSON.parse(res.data)



        encryptStorage.setItem('userId', res.data?.ResponseData?.id);

        encryptStorage.setItem('employeeId', res.data.ResponseData?.id);
        encryptStorage.setItem('username', res.data.ResponseData?.displayName);
        encryptStorage.setItem('department', res.data.ResponseData?.department);
        // encryptStorage.setItem('userId', res.data.ResponseData.id);
        encryptStorage.setItem('jwtToken', res.data.ResponseData?.jwtToken);
        encryptStorage.setItem('token', res.data.ResponseData?.access_token);
        encryptStorage.setItem('refresh', res.data.ResponseData?.refresh_token)
        let empID = res.data.ResponseData?.id;
        let roledata = await getroleName(empID);

        encryptStorage.setItem('groupid', roledata.data.data[0].group_id);

        if (roledata.data.data[0].group_id === 3) {
            encryptStorage.setItem('role', 'Team Member');
        } else if (roledata.data.data[0].group_id === 1) {
            encryptStorage.setItem('role', 'Hr Manager');
        } else if (roledata.data.data[0].group_id === 2) {
            encryptStorage.setItem('role', 'Manager');
        } else if (roledata.data.data[0].group_id === 4) {
            encryptStorage.setItem('role', 'Hr');
        }
        let response = await getHiringTeamLogin({ emp_id: empID });
        if (response?.data?.data?.length > 0) {
            encryptStorage.setItem('recruitRole', 'Panel Member');
        }

        //PC_FG_118
        if (encryptStorage.getItem('token')) {
            
            //PC_FG_120
            let response = await getSecAudits(
                {
                    token: encryptStorage.getItem('token'),
                    userId: encryptStorage.getItem('employeeId'),
                });
            //PC_FG_126
            let response1 = await getGRC(
                {
                    token: encryptStorage.getItem('token'),
                    userId: encryptStorage.getItem('employeeId')
                }
            )
            
            //PC_FG_132
            if (response?.data?.statusCode == 200 && response?.data?.data == true) {
                //PC_FG_133
                encryptStorage.setItem('secAudits', response?.data?.data)
            }
            //PC_FG_134
            if (response1?.data?.statusCode == 200 && response1?.data?.data == true) {
                //PC_FG_125
                encryptStorage.setItem('grc', response1?.data?.data);
            }
        }
        //
        // let response = await generateJWT(empID);
        //
        // encryptStorage.setItem('token',response.data.body.ResponseData[0].token)

        if (res.data.Success === true) {
            setIsLoading(true);
            window.location.href = '/Overview';
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="container-fluid">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-6 align-self-center">
                            <div className="row justify-content-center align-self-center">
                                <div className="col-md-6">
                                    <div className="text-center">
                                        <img src="/Images/hivelogo.svg" className="login-custom-logo-size" />
                                        <p className="urbanist-medium font-25 my-4">
                                            Hi Team,
                                            <span className="urbanist-bold">
                                                Welcome to <span className="login-text-orange">HIVE</span>
                                            </span>
                                        </p>
                                        <button type="button" className="btn hive-btn-primary urbanist-bold login-btn-style w-100">
                                            Login
                                        </button>
                                    </div>
                                    <div className="border-top mt-4 d-flex justify-content-between align-items-center">
                                        <label className="medium-text font-13 mt-3 login-label-color-1">For issues &amp; concerns</label>
                                        <label className="medium-text font-13 mt-3">Hivesupport@avasoft.com </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 align-self-center">
                            <div className="justify-content-center">
                                <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-indicators login-custom-alignment login-custom-carousel-indicators">
                                        <button
                                            type="button"
                                            data-bs-target="#carouselExampleIndicators"
                                            data-bs-slide-to={0}
                                            className="active"
                                            aria-current="true"
                                            aria-label="Slide 1"
                                        />
                                        <button
                                            type="button"
                                            data-bs-target="#carouselExampleIndicators"
                                            data-bs-slide-to={1}
                                            aria-label="Slide 2"
                                        />
                                        <button
                                            type="button"
                                            data-bs-target="#carouselExampleIndicators"
                                            data-bs-slide-to={2}
                                            aria-label="Slide 3"
                                        />
                                        <button
                                            type="button"
                                            data-bs-target="#carouselExampleIndicators"
                                            data-bs-slide-to={3}
                                            aria-label="Slide 4"
                                        />
                                    </div>
                                    <div className="carousel-inner login-custom-height">
                                        <div className="carousel-item active mt-5">
                                            <img
                                                src="/Images/Employee Relations.svg"
                                                className="d-block login-carousel-size m-auto mt-5"
                                                alt="Employee relations"
                                            />
                                            <p className="urbanist-bold font-20 my-3 text-center">Employee Relations</p>
                                            <p className="medium-text font-14 login-text-color text-center">
                                                Our efforts to create and maintain a positive relationship with our team members.
                                            </p>
                                        </div>
                                        <div className="carousel-item mt-5 ">
                                            <img
                                                src="/Images/Talent-acquisition.svg"
                                                className="d-block login-carousel-size m-auto mt-5"
                                                alt="Employee relations"
                                            />
                                            <p className="urbanist-bold font-20 my-3 text-center">Talent Acquisition</p>
                                            <p className="medium-text font-14 login-text-color text-center">
                                                The process of identifying and acquiring skilled people to meet our organizational needs.
                                            </p>
                                        </div>
                                        <div className="carousel-item mt-5">
                                            <img
                                                src="/Images/centralized employee recrods.svg"
                                                className="d-block login-carousel-size m-auto mt-5"
                                                alt="Employee relations"
                                            />
                                            <p className="urbanist-bold font-20 my-3 text-center">Centralized Employee Records</p>
                                            <p className="medium-text font-14 login-text-color text-center">
                                                Maintaining all the details associated with team members in a centralized area.
                                            </p>
                                        </div>
                                        <div className="carousel-item mt-5">
                                            <img
                                                src="/Images/leavemanagement.svg"
                                                className="d-block login-carousel-size m-auto mt-5"
                                                alt="Employee relations"
                                            />
                                            <p className="urbanist-bold font-20 my-3 text-center">Leave Management</p>
                                            <p className="medium-text font-14 login-text-color text-center">
                                                Manages the leaves and its approval and tracking of remaining leaves of team members
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 fixed-bottom bg-dark">
                            <p className="text-center mb-0 p-2 text-white">© {currentYear} Avasoft Inc.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LoginAuth;